module.exports = {
  getAuth: () => ({
    currentUser: null,
  }),
  getIdToken: async () => null,
  signInWithCustomToken: async () => {
    throw new Error('React Native Firebase auth is not supported in web build.');
  },
};
